export interface ParsedReleaseName {
  kind: 'release' | 'dev';
  major_group: string;
  release_seg: string | null;
}

/** Accept both automatically generated names and existing grouped release names. */
export function parseReleaseName(value: string): ParsedReleaseName | null {
  const name = value.trim();
  if (!name || name.length > 64) return null;
  const [date, channel, ...rest] = name.split('.');
  if (!/^\d{8}$/.test(date)) return null;
  if (channel === 'dev') {
    return rest.length === 0 ? { kind: 'dev', major_group: 'dev', release_seg: null } : null;
  }
  if (channel !== 'release' || rest.length === 0 || rest.some((part) => !part || /\s/.test(part))) {
    return null;
  }
  const seg = rest[rest.length - 1];
  if (!/^[0-9]+$/.test(seg) || seg.length > 32) return null;
  const group = ['release', ...rest.slice(0, -1)].join('.');
  if (group.length > 32) return null;
  return { kind: 'release', major_group: group, release_seg: seg };
}

/** Only a blank name requests auto-numbering; invalid input must not be discarded. */
export function getReleaseNameError(name: string): string | null {
  if (!name.trim() || parseReleaseName(name)) return null;
  return '版本号格式不正确，请填写 YYYYMMDD.release.N、YYYYMMDD.release.X.Y.N 或 YYYYMMDD.dev；留空则自动生成。';
}
